import { useContext, useEffect } from "react";
import Transfer from "../../../../images/Assign.svg";
import View from "../../../../images/EyeWhite.svg";
import Edit from "../../../../images/EditProfile.svg";
import { useNavigate } from "react-router-dom";
import useUrlParams from "../../../../customHooks/useUrlParams";
import { useLazyQuery } from "@apollo/client";
import
{
  AtsMomMasterOrderField,
  GetMomsData,
  GetMomsVars
} from "../Meetings/queries/types";
import { GetMoms } from "../Meetings/queries/query";
import { toIsoDate, toStandardDate } from "../../../../utils/UtilFunctions";
import { DEFAULT_TIME, pollingMinutes } from "../../../../utils/constants";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import RightArrow from "../../../../images/ArrowRight.svg";
import { AppContext } from "../../../../context/context";
import { empType } from "../../../../utils/Enum.types";

const MinutesOfMeeting = () =>
{
  const navigate = useNavigate();
  const { customer_id } = useUrlParams();
  const [ GetMomDetails, { data } ] = useLazyQuery<GetMomsData, GetMomsVars>(
    GetMoms,{
      pollInterval: pollingMinutes
    }
  );
  const { state } = useContext( AppContext );

  useEffect( () =>
  {
    if ( customer_id )
      GetMomDetails( {
        variables: {
          after: null,
          first: 10,
          customerID: customer_id,
          startDate: undefined,
          endDate: undefined,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsMomMasterOrderField.MEETING_DATE
          }
        }
      } );
  }, [ GetMomDetails, customer_id ] );



  return (
    <>
      {state.empSubType === empType.PMU ||
        state.empSubType === empType.VENDOR_MANAGER ||
        state.empSubType === empType.JCP ? (
        <div className="d-asset-details">
          <b className="d-main-page__block--title">Minutes of Meeting</b>
          <div className="d-asset-details__ul_mom">
            <ul>
              {data ? (
                data.GetMoms.edges.map( ( res, index ) =>
                {
                  return (
                    <li key={index}
                      onClick={() =>
                      {
                        navigate(
                          `/${ customer_id }/minutesofmeeting/${ res.node.id }`
                        );
                      }}
                    >
                      <div className="d-asset-details--flex"

                      >
                        <span>{index + 1}</span>
                        <label>{toStandardDate( res.node.meetingDate )}</label>
                      </div>
                      <div
                        className="d-asset-details--flex"

                      >
                        <img src={RightArrow} alt="" />
                      </div>
                    </li>
                  );
                } )
              ) : (
                <b className="nodata">No data found</b>
              )}
            </ul>
            <button
              className="d-asset-details__button"
              onClick={() =>
                navigate( `/${ customer_id }/minutesofmeeting/meetings` )
              }
            >
              View All
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="d-mom">
            <div className="d-mom__title">
              <b className="d-main-page__block--title">Minutes of Meeting</b>
              <input type="date" />
            </div>
            {/* <div className="d-mom__header">
        <div>
          <span>Meeting Held On : </span>
          <b>31-04-2025</b>
        </div>
        <div>
          <span>Total Projects : </span>
          <b>0</b>
        </div>
      </div> */}
            <ul className="d-mom__block">
              <li>
                <b>1. Asset Management</b>
                <div className="d-mom__block--flex">
                  0/5
                  <button className="d-mom__block--respond">
                    Respond <img src={Transfer} alt="" />
                  </button>
                  <button className="d-mom__block--view">
                    View <img src={View} alt="" />
                  </button>
                </div>
              </li>
              <li>
                <b>1. Signal Management</b>
                <div className="d-mom__block--flex">
                  0/5
                  <button className="d-mom__block--update">
                    Update <img src={Edit} alt="" />
                  </button>
                  <button className="d-mom__block--view">
                    View <img src={View} alt="" />
                  </button>
                </div>
              </li>
              <li>
                <b>1. Signal Management</b>
                <div className="d-mom__block--flex">
                  0/5
                  <button className="d-mom__block--update">
                    Update <img src={Edit} alt="" />
                  </button>
                  <button className="d-mom__block--view">
                    View <img src={View} alt="" />
                  </button>
                </div>
              </li>
              <li>
                <b>1. Signal Management</b>
                <div className="d-mom__block--flex">
                  0/5
                  <button className="d-mom__block--update">
                    Update <img src={Edit} alt="" />
                  </button>
                  <button className="d-mom__block--view">
                    View <img src={View} alt="" />
                  </button>
                </div>
              </li>
            </ul>
            <div className="d-mom__view">
              <button
                onClick={() =>
                  navigate( `/${ customer_id }/minutesofmeeting/meetings` )
                }
              >
                View All
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MinutesOfMeeting;
